// extracted by mini-css-extract-plugin
export default {"root":"_3hdMG","collapsed":"_3ZnSO"};